import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { del } from '../../utils/api';


const CounterDelete = ({ event_id, onDelete }) => {
	const { t } = useTranslation();
    const [ isDeleting, setIsDeleting ] = useState(false);
    const [ isError, setIsError ] = useState(false);

    const onClick = async () => {
        if(!window.confirm(t('counter.delete_confirm'))) {
			return;
		}
        setIsDeleting(true);
        setIsError(false);

        const result = await del(`/counters/${event_id}`);

        if(result.error) {
            setIsError(true);
        } else {
			onDelete();
        }
        setIsDeleting(false);
    };

    if(isDeleting) return <span>{t('common.loading')}</span>;
    if(isError) return <span>{t('common.error')}</span>;

    return <span onClick={() => onClick()}>{t('common.remove')}</span>;
};


CounterDelete.propTypes = {
    event_id: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
};

export default CounterDelete;